module.exports = __webpack_public_path__ + "static/journal-2-fb1a01fc72dac9d4659680641702a7fd.png";